



















































































































































import { computed, defineComponent, ref } from '@vue/composition-api';
import Draggable from 'vuedraggable';
import { UpsertModuleRequest } from '@front-app/api-generated/learning-management-api';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import { SETTINGS_ICON } from '@front-app/vendor/icon-definitions';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useTranslate } from '@front-app/hooks/useTranslate';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import { Size } from '@front-app/components/constants';
import CertificateBadge from '@front-app/modules/learningPrograms/components/CertificateBadge.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import DraggablePartCard from './DraggablePartCard.vue';
import TotalCreditsBadge from '../components/TotalCreditsBadge.vue';
import CompletionCreditsBadge from '../components/CompletionCreditsBadge.vue';
import PublishInfo from './PublishInfo.vue';

export default defineComponent({
	components: {
		SimpleCard,
		CtaButton,
		FontAwesomeIcon,
		Draggable,
		PlusButton,
		DraggablePartCard,
		CertificateBadge,
		ChevronIcon,
		IconButton,
		CompletionCreditsBadge,
		TotalCreditsBadge,
		PublishInfo,
	},
	props: {
		programId: {
			type: String,
			required: true,
		},
		moduleId: {
			type: String,
			required: true,
		},
		isSelected: Boolean,
	},
	setup(props, ctx) {
		const programsStore = getLearningProgramsStore();

		const arePartsExpanded = ref(false);
		// "module" is a reserved word
		const mod = computed(() => programsStore.getModule(props.moduleId));
		const addPart = (opener: FocusableElement) => {
			ctx.emit('create-part', { opener });
			arePartsExpanded.value = true;
		};
		const handleDragInput = (parts: string[]) => {
			programsStore.reorderModuleParts(props.programId, props.moduleId, parts);
		};

		const {
			track,
			isLoading: isUpdatingPublishInfo,
			isError: isErrorUpdatingPublishInfo,
		} = useAsyncStatus();
		const updateModule = async (updates: UpsertModuleRequest) => {
			await track(programsStore.updateModule(props.programId, props.moduleId, updates));
		};
		const $t = useTranslate(ctx);

		return {
			arePartsExpanded,
			mod,
			// Publishing the module
			isUpdatingPublishInfo,
			isErrorUpdatingPublishInfo,
			updateModule,
			// Parts
			addPart,
			handleDragInput,
			deletePart(moduleId: string, partId: string) {
				// eslint-disable-next-line no-alert
				const shouldDelete = window.confirm($t('lms.admin.delete-part-confirmation') as unknown as string);
				if (!shouldDelete) {
					return;
				}
				programsStore.deletePart(moduleId, partId);
			},
			addPartButtonSize: Size.TINY,
			chevronButtonSize: Size.SMALL,
			SETTINGS_ICON,
		};
	},
});
